export default {
  SET_FAILED_QUEUED_LOGS: function (state, payload) {
    state.failedQueuedLogs = payload;
  }
}
